const product_groups = {
	add_button: "Add Product Group",
	add_dialog: {
		description: "Add a new product group.",
		form: {
			description: "Description",
			hostfact_number: "Hostfact Product Number (optional)",
			hostfact_number_helper: "Fill in only if this group simulates a composite product.",
			hostfact_number_not_correct:
				'HostFact product number does not meet the requirements ("P" followed by 3 - 6 digits).',
			name: "Name",
		},
		locked_group: "This group is used for background processes and cannot be modified.",
		title: "Add Product Group",
	},
	add_product_dialog: {
		description: "Add a product to the selected product group.",
		form: {
			has_own_invoice_line: "Place on a separate invoice line",
			placeholder: "Select products",
			product_name: "Product Name",
		},
		title: "Add Product",
	},
	delete_dialog: {
		description: "Do you want to delete product group <strong>{{name}}</strong>?",
		group_not_empty: {
			description:
				"There are still products linked to this product group. Unlink them before deleting the product group.",
			title: "Group is not empty.",
		},
		title: "Delete Product Group",
	},
	disconnect_product: {
		description: "Do you want to unlink product <strong>{{name}}</strong>?",
		success_alert: "Unlinking the product was successful!",
		title: "Unlink Product",
		unknown_alert: "Unlinking the product failed! Please try again later.",
	},
	duplicate_dialog: {
		description: "Add a new product group using the values from the selected product group.",
		title: "Add Product Group",
	},
	edit_dialog: {
		description: "Edit the selected product group.",
		title: "Edit Product Group",
	},
	single_title: "Product Group",
	status: {
		add_product: {
			success:
				"Product <strong>{{product_name}}</strong> has been successfully added to the product group!",
			unknown:
				"Product <strong>{{product_name}}</strong> cannot be added to the product group at the moment. Please try again later.",
		},
		create: {
			success: "Product group has been added!",
			unknown: "Product group cannot be added at the moment. Please try again later.",
		},
		delete: {
			not_empty: "Product group cannot be deleted because there are still products linked to it.",
			success: "Product group has been deleted!",
			unknown: "Product group cannot be deleted at the moment. Please try again later.",
		},
		disconnect_product: {
			success: "Product has been successfully unlinked!",
			unknown: "Product cannot be unlinked at the moment. Please try again later.",
		},
		edit: {
			success: "Product group has been modified!",
			unknown:
				"The selected product group cannot be modified at the moment. Please try again later.",
		},
	},
	table: {
		description: "Description",
		details: "Details",
		name: "Name",
		number: "Group Number",
		products: "Products",
	},
	title: "Product Groups",
};

export default product_groups;
